import { useContext } from "react";
import { GlobalStateContext } from "./GlobalStateContext";
import { GlobalStateContextProps } from "./types";

// Custom hook to safely access GlobalStateContext
export const useGlobalState = (): GlobalStateContextProps => {
    const context = useContext(GlobalStateContext);
    if (!context) {
        throw new Error("useGlobalState must be used within a GlobalStateProvider");
    }
    return context;
};
